module.exports = __webpack_public_path__ + "static/img/office-aal.5f9659d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office-aal.png
// module id = 583
// module chunks = 1